import {
  getLeoUuid,
  LeoUUID,
  getObject,
  getLeoDate,
  LeoDate,
  getList,
} from "@surya-digital/leo-ts-types";
import { EmbedName, EmbedNameDTO } from "./embedName";
import { EmbedCode, EmbedCodeDTO } from "./embedCode";
import { SpocUserDetails, SpocUserDetailsDTO } from "../types/spocUserDetails";

export interface EmbedDetailDTO {
  id: string;
  name: EmbedNameDTO;
  code: EmbedCodeDTO;
  addedOn: string;
  spocs: SpocUserDetailsDTO[];
}

export class EmbedDetail {
  readonly isEmbedDetailEmbedDetail: boolean = true;

  readonly id: LeoUUID;
  readonly name: EmbedName;
  readonly code: EmbedCode;
  readonly addedOn: LeoDate;
  readonly spocs: SpocUserDetails[];


  constructor(
  id: LeoUUID, 
  name: EmbedName, 
  code: EmbedCode, 
  addedOn: LeoDate, 
  spocs: SpocUserDetails[]
  ) {
    this.id = id;
    this.name = name;
    this.code = code;
    this.addedOn = addedOn;
    this.spocs = spocs;
  }

  static fromDTO(dto: EmbedDetailDTO): EmbedDetail {
    const id = getLeoUuid(dto, "id", InvalidEmbedDetailIdError);
    const name = EmbedName.fromDTO(getObject(dto, "name", InvalidEmbedDetailNameError));
    const code = EmbedCode.fromDTO(getObject(dto, "code", InvalidEmbedDetailCodeError));
    const addedOn = getLeoDate(dto, "addedOn", InvalidEmbedDetailAddedOnError);
    const spocs = getList<SpocUserDetailsDTO, SpocUserDetails>(
      dto,
      "spocs",
      SpocUserDetails.fromDTO,
      InvalidEmbedDetailSpocsError
    );
    return new EmbedDetail(
      id,
      name,
      code,
      addedOn,
      spocs
    );
  }

  toDTO(): EmbedDetailDTO {
    const dto: EmbedDetailDTO = {
        id: this.id.toDTO(),
        name: this.name.toDTO(),
        code: this.code.toDTO(),
        addedOn: this.addedOn.toDTO(),
        spocs: this.spocs.map((e: SpocUserDetails) => { return e.toDTO() })
    };
    return dto;
  }
  }

EmbedDetail.prototype.toString = function toString(): string {
  return `EmbedDetail(id='${this.id}',name='${this.name}',code='${this.code}',addedOn='${this.addedOn}',spocs='${this.spocs}')`;
};

export class InvalidEmbedDetailError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidEmbedDetailError";
  }
}
export class InvalidEmbedDetailIdError extends InvalidEmbedDetailError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidEmbedDetailIdError";
  }
}

export class InvalidEmbedDetailNameError extends InvalidEmbedDetailError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidEmbedDetailNameError";
  }
}

export class InvalidEmbedDetailCodeError extends InvalidEmbedDetailError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidEmbedDetailCodeError";
  }
}

export class InvalidEmbedDetailAddedOnError extends InvalidEmbedDetailError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidEmbedDetailAddedOnError";
  }
}

export class InvalidEmbedDetailSpocsError extends InvalidEmbedDetailError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidEmbedDetailSpocsError";
  }
}
